import React from 'react';
import { TabBar } from './TabBar';
import { SplitViewContent } from './SplitViewContent';
import { useTabContext } from '@/contexts/TabContext';

interface SplitPanelProps {
  className?: string;
}

/**
 * SplitPanel - Renders the right panel's TabBar and content.
 * The content is rendered via SplitViewContent based on the active split tab's path.
 */
export const SplitPanel: React.FC<SplitPanelProps> = ({ className }) => {
  const { getRightTabs, focusPanel } = useTabContext();
  
  // Get the right panel tabs
  const rightTabs = getRightTabs();
  
  // Get the first (and currently only) right panel tab
  // In the current implementation, we only support one split at a time
  const activeTab = rightTabs[0];
  
  if (!activeTab) {
    return null;
  }

  // When clicking anywhere in the right panel, focus it and update URL
  const handlePanelClick = () => {
    focusPanel('right');
  };

  return (
    <div 
      className={`flex flex-col min-h-0 h-full w-full bg-surface overflow-x-hidden ${className || ''}`}
      onClick={handlePanelClick}
    >
      {/* Tab Bar for right panel */}
      <TabBar panel="right" />
      
      {/* Page Content - rendered based on the tab's path */}
      <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <SplitViewContent path={activeTab.path} className="h-full" />
      </div>
    </div>
  );
};

export default SplitPanel;

